import { useMemo, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import AIChatFAV from "../components/AIChat/AIChatFAV";


const AGENT_CONFIG = {
  "name": "Uwesome AI Assistant",
  "icon": {"icon": "fa fa-robot"},
}


function ChatAppView(){
  const { user } = useContext(AuthContext);

  const isAllowed = useMemo(() => (
    user &&
    ["systemadmin", "administrator"].includes(user?.user?.accessProfile?.name)
  ), [user]);

  return isAllowed ? <AIChatFAV agent={AGENT_CONFIG} /> : null
}


export default ChatAppView;
